export default __webpack_public_path__ + "static/media/flagCity.9f3cea26.svg";